import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

const indicadortipovalor = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/indicadortipovalor`,
    state: {
        tiposvalorbyindicador: []
    }

}).get({
    action: "get_tipovalorbyindicador",
    path: function (obj) {return `${obj.idindicador}`; },
    onSuccess: (state, payload) => {state.tiposvalorbyindicador = payload.data; }
    
}).post({
    action: "post_CrearyAsignartipovalor",
    path: function () {
        return `/nuevotipovalor`;
    }, 
    onSuccess: (state, payload) => {
        state.tiposvalorbyindicador = payload.data;
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).put({
    action: "post_Actualizartipovalor",
    path: function () {
        return `/editartipovalor`;
    }, 
    onSuccess: (state, payload) => {
        state.tiposvalorbyindicador = payload.data;
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).post({
    action: "post_estadotipovalor",
    path: function (obj) {
        return `/inactivar/${obj.idtipovalor}/${obj.idindicador}/${obj.state}`;
    }, 
    onSuccess: (state, payload ) => {
        state.tiposvalorbyindicador = payload.data;
    }
}).delete({
    action: "Deletemasive",
    path: function (obj) {
        return `${obj.idindicador}`
    },
    onSuccess: (state, payload) => {state.tiposvalorbyindicador = payload.data; },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).delete({
    action: "DeletetipoValor",
    path: function (obj) {
        return `${obj.idindicador}/${obj.idtipovalor}`
    },
    onSuccess: (state, payload) => {state.tiposvalorbyindicador = payload.data; },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        console.log('Error1', error)
    }
}).getStore();

indicadortipovalor.getters = {
    gindicadortipovalor: state => {
        return state.tiposvalorbyindicador
    }
}
export default indicadortipovalor;